defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/ClubSettings/SettingsOptions',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/ClubSettings/SettingsOptionsItem',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/LoadingRing'
  ],
  function (m, Ensighten, SettingsOptionsItem) {
    var SettingsOptions = {
      controller: function ({ controller, mode }) {
        Object.assign(this, controller);
        let trackingAction = 'create_club_settings_toggle';

        this.mode = mode;
        this.clubSettings = controller.clubSettings;
        this.clubModel = controller.clubModel;
        this.dictionary = controller.rootDictionary.get.bind({ prefix: 'Shared/ClubSettingsOptions/' });

        this.settingsOptionsLabels = {
          allowAllCreate: this.dictionary('AllowAllCreateLabel'),
          allowAllInvite: this.dictionary('AllowAllInviteLabel')
        };

        if (this.mode === 'edit') {
          trackingAction = 'settings_toggle';
          this.settingsOptionsLabels.isOpenForRegistration = this.dictionary('IsOpenForRegistrationLabel');
        }

        this.trackSettingChange = () => {
          const settingsKeys = Object.keys(this.settingsOptionsLabels);
          const trackingLabels = settingsKeys.map((key) => {
            return `${key}_${Boolean(this.clubSettings()[key]())}`;
          });
          Ensighten.pushGaEvent('spil_sammen', trackingAction, trackingLabels.join('/'));
        };
      },
      view: function (controller) {
        return m('.play-together__settings-options-list',
          Object.keys(controller.settingsOptionsLabels).map((option) => {
            return m(SettingsOptionsItem, { controller, option });
          })
        );
      }
    };

    // Public functions:
    return SettingsOptions;
  });
